<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>請求情報</h2>
      </v-col>
    </v-row>
    <v-row v-if="item.is_deleted">
      <v-col>
        <span class="subtitle-1 red--text">※このデータは削除済です。</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>顧客情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="顧客コード"
          readonly
          v-model="item.subscription.client.cd"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="請求方法"
          readonly
          v-model="item.billingmethod.name"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="業種分類"
          :items=$store.getters.industryCodes
          item-text="label"
          item-value="id"
          v-model="item.subscription.client.industrycode"
          readonly
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="会社名または個人名"
          v-model="item.name1"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="部署名"
          v-model="item.name2"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="課名"
          v-model="item.name3"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="名前"
          v-model="item.name4"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="敬称"
          readonly
          v-model="item.name_title"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="郵便番号"
          v-model="item.zipcode"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="都道府県"
          v-model="item.prefecture.name"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所1"
          v-model="item.address1"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所2"
          v-model="item.address2"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="電話番号"
          v-model="item.tel"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="FAX"
          v-model="item.fax"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          label="送付先情報"
          v-model="item.delivery_note"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>請求内容</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="請求コード"
          v-model="item.cd"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="開始日"
          v-model="item.startdate"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="終了日"
          v-model="item.enddate"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="商品カテゴリ"
          v-model="item.productdetail.product.productcategory.name"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="商品"
          v-model="item.productdetail.product.name"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="商品明細"
          v-model="item.productdetail.name"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="個数"
          readonly
          v-model="item.amount"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="契約金額"
          v-model="item.price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="送料"
          v-model="item.delivery_price"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="消費税"
          v-model="item.tax"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="4"
      ><v-btn class="red white--text" @click="download">請求書ダウンロード</v-btn></v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="請求日"
          readonly
          v-model="item.date_of_issue"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="1"
        sm="2"
      >
        <v-text-field
          label="発行回数"
          readonly
          v-model="item.publish_count"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="最終発行日"
          readonly
          v-model="item.last_publish_date"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="4"
      >
        <v-switch
          label="入金済み"
          @change="paymentCheck"
          v-model="item.has_payment"
        ></v-switch>
        <span v-if="item.paymenttype">{{ item.paymenttype.name }}({{ item.payment_date }})</span>
        <confirm-dialog
          ref="confirm"
          title="入金削除"
          message="入金情報を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deletePayment"
          @cancel="cancelPayment"
        >
        </confirm-dialog>
        <v-dialog v-model="payment_dialog" persistent>
          <v-card>
            <v-card-title>
              入金方法の選択
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-select
                      label="*入金方法"
                      :items=$store.getters.paymentTypes
                      item-text="name"
                      item-value="id"
                      v-model="paymenttype_id"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="*入金日"
                          readonly
                          v-on="on"
                          v-model="payment_date"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ja"
                        no-title
                        @input="fromDateMenu = false"
                        v-model="payment_date"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                  >
                      <v-btn
                        class="red white--text"
                        @click="savePayment()"
                      >
                       入金を登録する
                      </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                  >
                  <v-btn
                    @click="cancelPayment"
                    color="default">キャンセル</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="4"
      ><v-btn class="red white--text" @click="normal_download">請求書ダウンロード(通常)</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'
export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      item: {
        billingmethod: {},
        prefecture: {},
        client: {'cd': null, 'industrycode': null},
        productdetail: {
          product: {
            productcategory: {},
          }
        }
      },
      payment_dialog: false,
      paymenttype_id: null,
      payment_date: null,
    }
  },
  created() {
    this.getItem();
  },
  methods: {
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'InvoiceList'}).catch(()=>{});
      }
    },
    paymentCheck() {
      if (this.item.has_payment) {
        this.payment_dialog = true;
      } else {
        this.$refs.confirm.open();
      }
    },
    async deletePayment() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/${this.$route.params.id}/payment/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "設定しました", type: "success"});
        this.item.payment_date = null;
        this.item.paymenttype = null;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "設定に失敗しました", type: "error"});
        this.item.has_payment = true;
      }
    },
    async savePayment() {
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/${this.$route.params.id}/payment/`,
          {paymenttype_id: this.paymenttype_id, payment_date: this.payment_date},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "設定しました", type: "success"});
        this.item.payment_date = this.payment_date;
        this.item.paymenttype = this.$store.getters.paymentTypes.find((paymenttype) => paymenttype.id == this.paymenttype_id);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "設定に失敗しました", type: "error"});
        this.item.has_payment = false;
      }
      this.payment_dialog = false;
    },
    cancelPayment() {
      this.item.has_payment = !this.item.has_payment;
      this.payment_dialog = false;
    },
    async download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/${this.$route.params.id}/pdf/`,
          {
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
    async normal_download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoices/${this.$route.params.id}/normal_pdf/`,
          {
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>